"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorWeek = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const structural_organisms_1 = require("../structural-organisms");
const typography_1 = require("../../shared/typography");
const mark_boolean_value_1 = require("../../molecules/mark-boolean-value");
const styled_components_1 = __importDefault(require("styled-components"));
const renderLessonPreview = (lesson) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { onClick: lesson.onClick, children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: lesson.label }, void 0), lesson.shouldRenderStatus && (0, jsx_runtime_1.jsx)(mark_boolean_value_1.MarkBooleanValue, { value: lesson.isDone }, void 0)] }, lesson.label));
};
const BehaviorWeek = (props) => {
    return (0, jsx_runtime_1.jsx)(List, { children: props.behaviourWeekPreview.map(renderLessonPreview) }, void 0);
};
exports.BehaviorWeek = BehaviorWeek;
const List = (0, styled_components_1.default)(structural_organisms_1.ListWithMargin) `
  margin-bottom: ${({ theme }) => theme.spacings.xl};

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin-bottom: 0;
  }
`;
const Wrapper = styled_components_1.default.div `
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
  width: 100%;

  h2 {
    margin-bottom: 0;
  }

  & > div {
    margin-left: ${({ theme }) => theme.spacings.xl};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacings.m};
  }
`;
//# sourceMappingURL=BehaviorWeek.js.map